export default __webpack_public_path__ + "images/BAY.2a8d20e.png";